import { SET_TEMPLATEDELETE } from '../actions';

const templatedelete = (state = [], action) => {
  switch (action.type) {
	case SET_TEMPLATEDELETE:
      return [...action.value];  
    default: return state;
  }
}

export default templatedelete;
